import ProductList from './ProductList';
import ProductListFolder from './ProductListFolder';

interface RawProductList {
	id: string;
	name: string;
	parent: {
		id: string;
		name: string;
	} | null;
}

export default function mapProductList(list: RawProductList): ProductList {
	return new ProductList(
		list.id,
		list.name,
		list.parent !== null ? new ProductListFolder(list.parent.id, list.parent.name) : null
	);
}
